/**
 * core-js 3.27.2
 * © 2014-2023 Denis Pushkarev (zloirock.ru)
 * license: https://github.com/zloirock/core-js/blob/v3.27.2/LICENSE
 * source: https://github.com/zloirock/core-js
 */
import 'core-js/modules/es.array.find-last.js';
import 'core-js/modules/es.array.find-last-index.js';
import 'core-js/modules/es.array.push.js';
import 'core-js/modules/es.array.unshift.js';
import 'core-js/modules/es.regexp.flags.js';
import 'core-js/modules/es.typed-array.find-last.js';
import 'core-js/modules/es.typed-array.find-last-index.js';
import 'core-js/modules/web.dom-exception.stack.js';
import 'core-js/modules/web.immediate.js';
import 'core-js/modules/web.structured-clone.js';
